module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-1-zoom.ac4a2464.png";